"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabList = TabList;
var _react = _interopRequireDefault(require("react"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
//
// Main component
// -------------------------------------------------------------------------------------------------

/**
 * The `TabList` component implements the [_tablist_ aria control][listbox], which presents a list of
 * selectable tabs.
 *
 * [tablist]: https://www.w3.org/TR/wai-aria-practices/examples/tabs/tabs-1/tabs.html
 *
 * @alpha
 */
function TabList({
  appearance,
  children,
  testId
}) {
  return /*#__PURE__*/_react.default.createElement(_styled.StyledBase, {
    appearance: appearance,
    "data-testid": testId,
    role: "tablist"
  }, children);
}

//
// Sub-components
// -------------------------------------------------------------------------------------------------

TabList.Tab = Tab;
function Tab({
  children,
  disabled,
  selected,
  testId,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_styled.StyledTab, _extends({
    "aria-selected": selected,
    "data-testid": testId,
    disabled: disabled,
    role: "tab",
    type: "button"
  }, props), children);
}